import React from 'react';

/**
 * HeaderSkeleton provides a placeholder UI for the header during loading.
 */
const HeaderSkeleton = () => {
  return (
    <div className="header-skeleton bg-white h-[70px] flex items-center justify-between px-6 border-b border-gray-200 animate-pulse">
      {/* Left side - placeholder for maybe a search bar or title */}
      <div className="header-skeleton__left h-8 w-1/3 bg-gray-300 rounded"></div>

      {/* Right side - placeholder for profile dropdown */}
      <div className="header-skeleton__right flex items-center space-x-4">
        <div className="header-skeleton__profile-icon w-10 h-10 bg-gray-300 rounded-full"></div>
        <div className="header-skeleton__profile-text h-5 w-20 bg-gray-300 rounded"></div>
      </div>
    </div>
  );
};

export default HeaderSkeleton; 